import React, { Component } from "react";
import Core from "Core";
import { observer } from "mobx-react";

class Date extends Component {
  render() {
    const { label, model, dataMember, isValidDate } = this.props;

    return (
      <Core.Components.FormGroups.LabelValuePair label={label || ""}>
        <Core.Components.Inputs.Date
          model={model}
          dataMember={dataMember}
          isValidDate={isValidDate}
        />
      </Core.Components.FormGroups.LabelValuePair>
    );
  }
}

export default observer(Date);



// WEBPACK FOOTER //
// ./src/Core/Components/FormGroups/Date.js